var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55555 8.62432L10.6758 15.7444C10.8404 15.9092 11.0603 16 11.2947 16C11.5291 16 11.7489 15.9092 11.9136 15.7444L12.438 15.2202C12.7792 14.8786 12.7792 14.3234 12.438 13.9823L6.45895 8.00332L12.4446 2.01768C12.6093 1.85286 12.7002 1.63316 12.7002 1.39888C12.7002 1.16435 12.6093 0.944643 12.4446 0.779701L11.9202 0.255608C11.7554 0.0907965 11.5357 9.53674e-07 11.3013 9.53674e-07C11.0669 9.53674e-07 10.8471 0.0907965 10.6824 0.255608L3.55555 7.38218C3.39048 7.54752 3.29982 7.76826 3.30034 8.00293C3.29982 8.2385 3.39048 8.45912 3.55555 8.62432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9dcab6ee56589c578ee5800e9210490d.svg";
export { ForwardRef as ReactComponent };